module.exports = __webpack_public_path__ + "img/4.d7bcd49a.svg";